import React from 'react';
import ReactTooltip from 'react-tooltip';
import {
	Loader,
	BaasicTable,
	BaasicConfirmModal,
	TableFilter,
	BaasicHeader,
	BaasicSelect,
	BaasicTableExport,
} from 'core/components';
import { ReceivingStore } from 'modules/receiving/stores';
import { defaultTemplate } from 'core/hoc';
import { FileNames } from 'common/constants';

const ReceivingListTemplate = ({
	t,
	viewStore,
	viewStore: {
		listStore,
		tableData,
		queryUtility,
		loading,
		deleteConfirmModalParams,
		baasicTableSettingsViewStore,
		headerCell,
		columnFilterSetup,
		removeFiltersModal: { removeFiltersConfirm },
	},
	actions,
	showActions,
}) => {
	if (loading) return <Loader />;
	return (
		<section className="layout__main__body">
			<BaasicHeader title="MAINMENU.CONTAINERS.TITLE" baasicTableSettingsViewStore={baasicTableSettingsViewStore}>
				<BaasicTableExport tableViewStore={viewStore} fileTitle={FileNames.Receiving} />
			</BaasicHeader>
			<BaasicTable
				{...{
					listStore,
					tableData,
					queryUtility,
					actions,
					headerCell,
					showActions,
					viewStore,
				}}
				data={listStore.data.slice()}
			/>
			<TableFilter viewStore={viewStore} columnFilterSetup={columnFilterSetup} />
			<BaasicConfirmModal modalParams={deleteConfirmModalParams} />
			<BaasicConfirmModal modalParams={removeFiltersConfirm} />
			<ReactTooltip />
		</section>
	);
};

export default defaultTemplate(ReceivingListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/receiving/pages/ReceivingListTemplate.jsx